import React from 'react';
import styled from '@emotion/styled';
import { Facebook, MessageSquare, MessageCircle } from 'react-feather';

// Components
import Header from '../components/header';
import Card from '../components/card';
import Button from '../components/button';
import CardLayout from '../components/card-layout';

export default function Choose() {
  return (
    <Container>
      <Header>Hassellöf Store, Stockholm</Header>
      <Card fillAvailable={true} background="none">
        <Title>How would you like us to send you queue updates?</Title>
      </Card>
      <Button>
        <CardLayout center icon={<MessageCircle size={32} />}>
          WhatsApp
        </CardLayout>
      </Button>
      <Button background="#2E89FF">
        <CardLayout center icon={<Facebook size={32} />}>
          Facebook
        </CardLayout>
      </Button>
      <Button ghost>
        <CardLayout center icon={<MessageSquare size={32} />}>
          Text Message
        </CardLayout>
      </Button>
    </Container>
  );
}

const Title = styled('h1')`
  color: #fff;
  text-align: center;
  font-weight: bold;
  font-size: 40px;
  padding: 0 40px;
  margin: auto;
`;

const Container = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
`;
